import React from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Text } from './Texte';
import { Check, UserRound, Ionicons } from './icons';
import { colors, formes, gradients, radius, shadow, spacing } from '../theme/tokens';
import { FEATURE_ACCENTS } from '../theme/featureAccents';

export interface CarteProfilLinkedinProps {
  // Les trois blocs que l'audit lit : Titre, À propos, Expériences.
  blocs: string[];
  testID?: string;
}

/**
 * Aperçu illustré d'un profil LinkedIn : bannière, avatar, deux lignes grisées et les blocs que
 * l'audit va lire. DÉCORATIF : ce n'est pas le profil de la personne (les lignes grises ne sont
 * pas du texte), donc masqué au lecteur d'écran. Le trait de balayage animé de la maquette n'est pas
 * reproduit : figé, il se lirait comme un défaut ; il viendra avec « réduire les animations ».
 */
export function CarteProfilLinkedin({ blocs, testID }: CarteProfilLinkedinProps) {
  return (
    <View
      testID={testID}
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      style={styles.carte}
    >
      <LinearGradient colors={gradients.profilLinkedin} start={{ x: 0, y: 0 }} end={{ x: 1, y: 1 }} style={styles.banniere}>
        <Ionicons name="logo-linkedin" size={22} color="rgba(255,255,255,0.9)" />
      </LinearGradient>
      <View style={styles.corps}>
        <View style={styles.avatar}>
          <UserRound size={24} color={colors.violetProfil} strokeWidth={2} />
        </View>
        <View style={styles.ligneNom} />
        <View style={styles.ligneTitre} />
        <View style={styles.blocs}>
          {blocs.map((bloc) => (
            <View key={bloc} style={styles.bloc}>
              <Check size={11} color={FEATURE_ACCENTS.linkedin.ink} strokeWidth={3.2} />
              <Text style={styles.blocTexte}>{bloc}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  carte: { overflow: 'hidden', backgroundColor: colors.white, borderRadius: formes.rayon.lg, ...shadow.card },
  banniere: { height: 66, alignItems: 'flex-end', paddingHorizontal: 13, paddingTop: 11 },
  corps: { paddingHorizontal: spacing.lg, paddingBottom: spacing.md },
  avatar: {
    width: 58,
    height: 58,
    marginTop: -29,
    borderRadius: radius.pill,
    backgroundColor: '#EDE3FB',
    borderWidth: 4,
    borderColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ligneNom: { width: 132, height: 11, borderRadius: 6, backgroundColor: '#DCE1EC', marginTop: spacing.sm },
  ligneTitre: { width: 210, maxWidth: '90%', height: 8, borderRadius: 4, backgroundColor: '#E8ECF3', marginTop: 7 },
  blocs: { flexDirection: 'row', gap: 6, marginTop: spacing.md },
  bloc: {
    height: 24,
    paddingHorizontal: 9,
    borderRadius: 12,
    backgroundColor: FEATURE_ACCENTS.linkedin.tint,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  blocTexte: { fontSize: 11.5, fontWeight: '800', color: FEATURE_ACCENTS.linkedin.ink },
});
